/** Respect the presentation's readability cap: rows replace overlap when the
 * visible cards cannot fit without covering more than that cap permits. */
export function fittedFan(count: number, cardWidth: number, available: number | null, maxOverlap: number): { overlap: number; wrap: boolean } {
  if (available === null || count < 2) return { overlap: 0, wrap: false };
  const needed = Math.max(0, (count * (cardWidth + 8) - 8 - available) / ((count - 1) * cardWidth));
  return needed > maxOverlap ? { overlap: 0, wrap: true } : { overlap: needed, wrap: false };
}
